module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a42f3e375714dfc9e240ad5d695ea4f5.png";